/**
*  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UserProfileResponse } from './userprofileresponse';
import { CommonConstants } from '../../../common/constants/common-constants';

@Injectable()
export class UserProfileService {

    constructor(public http: HttpClient) {
    }

 // to check whether the user is internal/ldap user
    isLDAP(data) {
        if (data.hasOwnProperty('ldapSourceId')) {
            return true;
        } else {
            return false;
        }
    }

    // Get call to fetch user profile details
    public getUserprofile() {
        return this.http.get<UserProfileResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/me');
    }

    // Post call for to update user profile
    public updateProfile(username: string, password: string, email: string) {
        return this.http
            .put<UserProfileResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/me', {
                'username': username,
                'password': password,
                'email': email
            });
    }

    public getUserDashletOrder() {
        return this.http.get(CommonConstants.SERVICE_VERSION_PATH_V1 + '/me/dashletOrder');
    }

    public updateUserDashletOrder(params: HttpParams) {
        return this.http.put(CommonConstants.SERVICE_VERSION_PATH_V1 + '/me/updaetedashletOrder', {}, {params});
    }

}
